import React from 'react';
import { Icon } from 'semantic-ui-react';
import * as Styles from './Alert.style';
import LoadingImage from 'assets/svg/loading.svg';
import { H5, H6, P } from 'utils/resuable-css';
import { useTranslation } from 'react-i18next';

const Alerts = (props) => {
  const { t } = useTranslation();
  const {
    isFetching,
    alertId,
    isOpenAlert,
    openAlerts,
    closedAlerts,
    loading,
    handleChangeAlert,
    onMutedAlert,
    loadingMuteAlert,
  } = props;
  return (
    <Styles.DraggableContainer id="alertParent">
      <div>
        <div id="alertChild">
          <Styles.TopBar>
            <Styles.Left>
              <Icon name="warning sign" color="red" />
              <H5>{t('dashboard.string1')}</H5>
              <P className="count">
                {t('dashboard.string2', { count: loading ? 0 : isOpenAlert ? openAlerts?.count : closedAlerts?.count })}
              </P>
              {isFetching ? (
                <img src={LoadingImage} height={28} width={28} alt="loading" />
              ) : (
                <div style={{ width: '29px', height: '28px' }} />
              )}
            </Styles.Left>
            <Styles.Right>
              <Icon name="expand" />
            </Styles.Right>
          </Styles.TopBar>
        </div>
        <Styles.Content>
          {isOpenAlert
            ? openAlerts?.alerts.map((alert) => (
                <Styles.NotificationContainer key={alert.id}>
                  <Styles.Alert>
                    <H6>{alert.text1_en}</H6>
                    <P>{alert.text2_en}</P>
                  </Styles.Alert>
                  {alertId === alert.id && loadingMuteAlert ? (
                    <img src={LoadingImage} height={28} alt="loading" />
                  ) : (
                    <Icon
                      onClick={() => onMutedAlert(alert?.id, alert?.muted)}
                      name={alert.muted === '0' ? 'bell' : 'bell slash'}
                      style={{ color: alert.muted === '0' ? 'red' : '#666666' }}
                      size="large"
                    />
                  )}
                </Styles.NotificationContainer>
              ))
            : closedAlerts?.alerts.map((alert) => (
                <Styles.NotificationContainer key={alert.id}>
                  <Styles.Alert>
                    <H6>{alert.text1_en}</H6>
                    <P>{alert.text2_en}</P>
                  </Styles.Alert>
                </Styles.NotificationContainer>
              ))}
        </Styles.Content>
      </div>
      <Styles.TradeContainer>
        <P onClick={() => handleChangeAlert(true)} style={{ color: isOpenAlert ? '#ff904f' : '#666666' }}>
          {t('dashboard.string3')}
        </P>
        <P className="space">|</P>
        <P style={{ color: isOpenAlert ? '#666666' : '#ff904f' }} onClick={() => handleChangeAlert(false)}>
          {t('dashboard.string4')}
        </P>
      </Styles.TradeContainer>
    </Styles.DraggableContainer>
  );
};
export default Alerts;
